module.exports = __webpack_public_path__ + "img/logo1.157127ee.png";